import React from 'react';
import styles from './Search.module.scss';

/**
 * Wraps the first case-insensitive occurrence of `query` within `text` in a styled <mark>.
 * Uses indexOf (no regex) so special characters in the query (m&a, c++) can't break it.
 * Titles arrive as plain text, so no HTML decoding is needed and React escapes any stray markup.
 */
export const highlightMatch = (text: string, query: string): React.ReactNode => {
  const trimmedQuery = query.trim();
  if (!trimmedQuery || !text) return text;

  const index = text.toLowerCase().indexOf(trimmedQuery.toLowerCase());
  if (index === -1) return text;

  const before = text.slice(0, index);
  const match = text.slice(index, index + trimmedQuery.length);
  const after = text.slice(index + trimmedQuery.length);

  return (
    <>
      {before}
      <mark className={styles.highlight}>{match}</mark>
      {after}
    </>
  );
};
